import { render } from "./PsaAdditionalInfo.vue?vue&type=template&id=a0179c84&scoped=true"
import script from "./PsaAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./PsaAdditionalInfo.vue?vue&type=script&lang=js"

import "./PsaAdditionalInfo.vue?vue&type=style&index=0&id=a0179c84&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0179c84"]])

export default __exports__